'use strict';

var React = require('react');
var headerCheckbox = require('./Cells/headerCheckbox.js');
require('./Cells/header.js');
require('../Tooltip/component.js');
require('../Icon/component.js');
require('./Cells/headerIcon.styles.js');
require('./Cells/cell.js');
var cellCheckbox = require('./Cells/cellCheckbox.js');
require('../forms/Select/Control.js');
require('../forms/Select/Option.js');
require('./Cells/cellSelect.styles.js');
require('../forms/Switch/component.js');
require('./Cells/cellSwitch.styles.js');
require('../Text/component.js');
require('./Cells/cellSubText.styles.js');
require('../Pill/pill.styles.js');
require('../Pill/pillButton.styles.js');
require('./Cells/cellPill.styles.js');
require('../Chip/component.js');
require('./Cells/cellChip.styles.js');
require('../Tag/component.js');
require('./Cells/cellTag.styles.js');
require('./Cells/cellActions.js');
require('./Cells/cellIcon.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function useSelection(engine, withSelection, onFocusRow) {
    const [columnsWithSelection, setColumnsWithSelection] = React.useState([]);
    const [colSizeWithSelection, setColSizeWithSelection] = React.useState({});
    const factoryHandleSelectChange = (d) => () => {
        engine.selectUnselect(d[engine.keyField]);
    };
    const isCheckAllChecked = () => engine.state.data.length > 0 &&
        engine.state.data.map(d => d[engine.keyField]).every(r => engine.state.selectedRows.includes(r));
    const handleSelectAll = React.useCallback(() => {
        if (isCheckAllChecked()) {
            engine.unSelectAll();
        }
        else {
            engine.setAllSelectRow(engine.state.data.map(d => d[engine.keyField]));
        }
    }, [engine.state.data, engine.state.selectedRows]);
    React.useEffect(() => {
        setColumnsWithSelection(withSelection
            ? [
                {
                    key: engine.keyField,
                    headerCustom: headerProps => (React__default.default.createElement(headerCheckbox.HeaderCheckbox, { ...headerProps, name: "selectAll", onChange: handleSelectAll, checked: isCheckAllChecked(), resize: { enable: false } })),
                    cell: cellProps => (React__default.default.createElement(cellCheckbox.CellCheckbox, { ...cellProps, name: cellProps.data[engine.keyField], onChange: factoryHandleSelectChange(cellProps.data), checked: engine.state.selectedRows.includes(cellProps.data[engine.keyField]) })),
                    width: '50px',
                },
            ]
            : []);
        setColSizeWithSelection(withSelection ? { [engine.keyField]: '50px' } : {});
    }, [withSelection, handleSelectAll]);
    const factoryHandleOnFocusRow = (d) => () => {
        if (d !== engine.state.focusRow && onFocusRow) {
            engine.setFocusRow(d);
            onFocusRow(d);
        }
    };
    return { columnsWithSelection, colSizeWithSelection, factoryHandleOnFocusRow };
}

exports.useSelection = useSelection;
//# sourceMappingURL=useSelection.js.map
